import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
  HOUSEKEEPING_EDIT,
  HOUSE_KEEPING_TAB_LIST,
  ITEMS_COUNT,
} from '../../../../../constants/ServiceConstants';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_SERVICE_REQUEST,
} from '../../../../../constants/RoleConsts';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './HouseKeepingView.scss';
import moment from 'moment';
import { allHouseKeeping } from '../../../servicesSlice';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { decodeMediaKeyValue } from '../../../../../utils/mediaUtils';

const HouseKeepingView = (props) => {
  const { onViewToggle, onDrawerToggle, object, permissions } = props;
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const [obj, setObj] = useState();
  const allHouseKeepingSelector = useSelector(allHouseKeeping);
  const [visibleItemCount, setVisibleItemCount] = useState(ITEMS_COUNT);

  useEffect(() => {
    if (tabValue === 1) {
      setVisibleItemCount(ITEMS_COUNT);
    }
  }, [tabValue]);

  useEffect(() => {
    if (allHouseKeepingSelector.length) {
      let houseKeepingObj = {
        ...allHouseKeepingSelector.find((info) => info.id === object.id),
      };
      setObj(houseKeepingObj);
    }
  }, [allHouseKeepingSelector]);

  const onOpenDrawer = (event) => {
    event.stopPropagation();
    onDrawerToggle(HOUSEKEEPING_EDIT, true, obj);
  };

  const renderScreen = () => {
    return (
      <>
        {tabValue === 0 && (
          <div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-4'>
                <div className='details-label'>Service Name</div>
                <div className='details-value preview-breaks'>{obj.name}</div>
              </div>
              <div className='col-md-8'>
                <div className='details-label'>Service Code</div>
                <div className='details-value'>{obj.code ? obj.code : '---'}</div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-fluid'>
                <div className='details-label'>Description</div>
                <div className='details-value preview-breaks'>
                  {obj.description ? obj.description : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Confirmation Message</div>
                <div className='details-value'>
                  {obj.confirmationMessage ? obj.confirmationMessage : '---'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Max Quantity</div>
                <div className='details-value'>
                  {obj.maxQuantity && obj.maxQuantityActive ? obj.maxQuantity : 'NA'}
                </div>
              </div>
            </div>
            <div className='row mx-4 mt-3'>
              <div className='col-md-6'>
                <div className='details-label'>Schedule</div>
                {obj.schedule?.length > 0
                  ? obj.schedule.map((sched, i) => (
                      <div key={i} className='details-value'>
                        {sched === 'CUSTOM'
                          ? sched.charAt(0).toUpperCase() +
                            sched.slice(1).toLowerCase() +
                            ' - ' +
                            obj.customSchedule
                          : sched.charAt(0).toUpperCase() + sched.slice(1).toLowerCase()}
                      </div>
                    ))
                  : 'NA'}
              </div>
            </div>
            <div className='row mx-4 mt-4'>
              {obj.customAttributes &&
                obj.customAttributes.length > 0 &&
                obj.customAttributes.map((item, index) => (
                  <div key={index} className='col-md-6 mb-2'>
                    <div className='details-label'>{item.key}</div>
                    <div className='details-value'>{item.value}</div>
                  </div>
                ))}
            </div>
          </div>
        )}
        {tabValue === 1 && (
          <div className='row mx-4 mt-3 overflow-auto h-100 accordion-div-housekeeping'>
            <div className='col-md-12'>
              <div className='details-label'>Items</div>
              {obj.isItemActive ? (
                <div>
                  <div className='details-value'>
                    {obj?.items[0]?.name ? obj?.items?.length : 'NA'}
                  </div>
                  <div className='col-md-12 '>
                    {obj?.items?.slice(0, visibleItemCount)?.map((item, i) => (
                      <div className='row mt-3' key={i}>
                        <div className='col-md-12 bg-info p-2'>
                          <Accordion>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls='panel1a-content'
                              id='panel1a-header'
                            >
                              <div className='mt-1'>
                                <div>
                                  <span className='details-label'>Item Name: </span>
                                  <span className='details-value'>{item?.name}</span>
                                </div>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className='col-12 pe-3'>
                                <div className='row'>
                                  <div>
                                    <div className='details-label'>
                                      <span>Item</span> <span>Code</span>
                                    </div>
                                    <div className='details-value'>
                                      {item?.id ? item?.id : '---'}
                                    </div>
                                  </div>
                                </div>
                                <div className='row mt-3'>
                                  <div className='col-fluid'>
                                    <div className='details-label'>Description</div>
                                    <div className='details-value'>
                                      {item?.description ? item?.description : '---'}
                                    </div>
                                  </div>
                                </div>
                                <div className='row mt-3'>
                                  <div className='col-fluid'>
                                    <div className='details-label'>Type</div>
                                    <div className='details-value'>
                                      {item?.itemDataType ? item?.itemDataType.charAt(0).toUpperCase() + item?.itemDataType.slice(1) : '---'}
                                    </div>
                                  </div>
                                </div>
                                <div className='row mt-3'>
                                  <div className='col-fluid'>
                                    <div className='details-label'>Max Quantity</div>
                                    <div className='details-value'>
                                      {item?.maxQuantity && item?.maxQuantityActive
                                        ? item?.maxQuantity
                                        : 'NA'}
                                    </div>
                                  </div>
                                </div>
                                <div className='row mt-3'>
                                  <div className='col-fluid'>
                                    <div className='details-label'>Status</div>
                                    <div className='details-value'>
                                      {item?.isActive ? 'Active' : 'Inactive'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </div>
                    ))}
                    {visibleItemCount < obj?.items?.length && (
                      <Button
                        variant='outlined'
                        size='small'
                        onClick={() =>
                          setVisibleItemCount((count) =>
                            Math.min(count + ITEMS_COUNT, obj?.items?.length),
                          )
                        }
                        style={{ margin: '16px auto', display: 'block' }}
                      >
                        Load {Math.min(ITEMS_COUNT, obj?.items?.length - visibleItemCount)} more…
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                'Inactive'
              )}
            </div>
          </div>
        )}
        {tabValue === 2 && obj.hours && obj.hours.length > 0 && (
          <div>
            {obj.hours[0].everyday && obj.hours[0].allTime ? (
              <div>
                <div className='row mx-4 mt-3'>
                  <div className='col-md-6'>
                    <div className='details-label'>Available On</div>
                    <div className='details-value'>Everyday</div>
                  </div>
                </div>
                <div className='row mx-4 mt-4'>
                  <div className='col-md-6'>
                    <div className='details-label'>Hours</div>
                    <div className='details-value'>24*7</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className='row mx-4 mt-3'>
                <div className='col-md-6'>
                  <div className='details-label'>Open on</div>
                  <div className='details-value'>
                    {obj.hours.map((hour) => (
                      <div className='d-flex'>
                        <div className='me-1'>
                          {hour.everyday
                            ? 'Everyday :'
                            : hour?.day
                                .map(
                                  (h) =>
                                    ` ${h.substring(0, 1).toUpperCase()}${h
                                      .substring(1, 3)
                                      .toLowerCase()}`,
                                )
                                .join(', ') + ' :'}
                        </div>
                        <div>
                          {hour.allTime
                            ? '24*7'
                            : moment(hour.open, 'HH:mm').format('LT') +
                              ' - ' +
                              moment(hour.close, 'HH:mm').format('LT')}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {tabValue === 3 && (
          <div className='row mx-4 mt-3'>
            <div className='row pt-4'>
              <MediaViewer
                images={obj.images}
                videos={(() => {
                  const { Video: videoMediaContent } = decodeMediaKeyValue(obj?.mediaContent);
                  return videoMediaContent || obj.videos || {};
                })()}
                gifs={(() => {
                  const { GIF: gifMediaContent } = decodeMediaKeyValue(obj?.mediaContent);
                  return gifMediaContent || obj.gifs || {};
                })()}
              />
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      {obj && (
        <DetailViewLayout
          onClickEdit={onOpenDrawer}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          tabList={HOUSE_KEEPING_TAB_LIST}
          onViewToggle={onViewToggle}
          title={obj.name}
          createdUserId={obj.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_SERVICE_REQUEST] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default HouseKeepingView;
